import { GestureResponderEvent, Image, Platform, Pressable, StyleSheet, Text, View, ViewStyle } from 'react-native';
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Meta } from '../../../../imsdk/db/t_msg';
import { ChatPopMenu } from '../ChatPopMenu';
import { color_666666, color_999999, color_FF6E6E } from '../../../assets/style/colors';
import { Str_ChatRecord, Str_File, Str_Img, Str_RtcAudio, Str_RtcVideo, Str_Talk, Str_Video, Str_Voice, Str_You } from '../../../language/string_res';
import { getUid } from '../../../store/token';
import { MessageType } from '../../../constants/types';
import FastImage from 'react-native-fast-image';
import LottieView from 'lottie-react-native';
import { chatViewStyles } from '../ChatViewItemRender';
import { useAppNavigation } from '../../navigation';
import { MediaPreviewItem, MessageSchema } from '../../../realm/schema';
import VoicePlayManager, { VoicePlayEvent, VoicePlayState } from '../../../utils/VoicePlayManager';
import { fixRemoteUrl } from '../../../../imsdk/api';
import { useStore } from '../../../store/UserStore';
import * as ImSdk from "../../../../imsdk/api";
import { getDisplayName, isGroupTopic } from '../../../utils/utils';

export type QuoteRenderProps = {
	disabled?: boolean;
	msg?: MessageSchema; // msg/meta二选一, 但只有msg才有handleQuoteLocal回调
	meta?: Meta; // msg/meta二选一, 但只有msg才有handleQuoteLocal回调
	maxLine?: number;
	handleQuoteLocal?: (msg: MessageSchema) => void;
	style?: ViewStyle;
};

const QuoteRender = (props: QuoteRenderProps) => {
	const navigation = useAppNavigation();
	const [quoteMeta, setQuoteMeta] = useState<Meta>(props.meta ? props.meta : props.msg?.meta ?? {});
	const [showPopover, setShowPopover] = useState(false);
	const quoteType = quoteMeta.quoteType as MessageType;
	const content = quoteMeta.quoteCnt as string;
	const [imageUrl, setImageUrl] = useState(quoteMeta.thumbnailPath);
	const lottie = useRef<LottieView>(null);
	const source = require('../../../assets/lottie/receive.json');
	const textStyle = chatViewStyles.receivedText;
	const maxLine = props.maxLine || 2;
	const mid = quoteMeta.quoteMid;
	const { state } = useStore();
	const [quoteUserName, setQuoteUserName] = useState('');
	const [popoverPosition, setPopoverPosition] = useState({ x: 0, y: 0 });


	useEffect(() => {
		if (quoteType === MessageType.IMAGE) {
			if ((quoteMeta.upload_path?.length ?? 0) !== 0) {
				setImageUrl(quoteMeta.upload_path);
			} else if (quoteMeta.thumbnail.length !== 0) {
				setImageUrl(quoteMeta.thumbnail);
			} else {
				setImageUrl(quoteMeta.quoteCnt);
			}
		} else if (quoteType === MessageType.VIDEO) {
			if (quoteMeta.thumbnail.length !== 0) {
				setImageUrl(quoteMeta.thumbnail);
			} else {
				//是否也需要做制作封面处理
			}
		} else if (quoteType === MessageType.DOCUMENT) {
			//TODO: 文件消息渲染，暂时没有好的封面图，先用默认图
		} else if (quoteType === MessageType.VOICE) {
			// 监听播放事件广播
			VoicePlayManager.addListener(handlePlayEvent);
		}

		getQuoteUserName(quoteMeta.quoteUid, quoteMeta.quoteUser).then(name => {
			setQuoteUserName(name);
		});


		return () => {
			if (quoteType === MessageType.VOICE) {
				VoicePlayManager.removeListener(handlePlayEvent);
			}
		};
	}, [quoteMeta]);

	/**
	 * 处理播放事件广播
	 * 只有当广播的 mid 与当前组件的 mid 相同时才处理
	 */
	const handlePlayEvent = (event: VoicePlayEvent) => {
		if (event.mid !== mid) {
			return;
		}

		if (event.state === VoicePlayState.Playing) {
			playAnim();
		} else if (event.state === VoicePlayState.Ended || event.state === VoicePlayState.Error) {
			pauseAnim();
		}
	};

	/**
	 * 播放动画
	 */
	const playAnim = () => {
		lottie?.current?.reset();
		lottie?.current?.play();
	};

	/**
	 * 暂停动画
	 */
	const pauseAnim = () => {
		lottie?.current?.reset();
	};

	const handleClick = () => {
		if (props.disabled === true) {
			return;
		}

		if (quoteType === MessageType.IMAGE || quoteType === MessageType.VIDEO) {
			const item: MediaPreviewItem = {
				type: quoteType,
				mid: quoteMeta.mid,
				index: 0,
				currentIndex: 0,
				content: fixRemoteUrl(content),
				upload_path: quoteMeta.upload_path,
				thumbnailPath: quoteMeta.thumbnail,
			};

			navigation.navigate('MediaPreviewScreen', { items: [item], initialIndex: 0 });
			return;
		}

		if (quoteType === MessageType.TEXT) {
			//预览文本
			navigation.navigate('HtmlTextScreen', { isHtmlStr: false, title: '', text: content });
			return;
		}

		if (quoteType === MessageType.VOICE) {
			// 通过单例管理器播放，自动处理停止逻辑和动画广播
			VoicePlayManager.play(quoteMeta.quoteMid, fixRemoteUrl(content), 'Speaker');
			return;
		}

		if (quoteType === MessageType.TALK) {
			try {
				const { title, selectMessages } = JSON.parse(content);
				// 跳转聊天详情展示页面
				navigation.push('ChatTalk', { tid: quoteMeta.quoteTid, title: title, selectMessages: selectMessages });
			} catch (error) { }
			return;
		}
	};

	const handleContextMenu = (event: GestureResponderEvent) => {
		event.preventDefault?.();
		event.stopPropagation?.();

		if (showPopover) {
			setShowPopover(false);
			return;
		}

		const { pageX, pageY } = event.nativeEvent;

		setPopoverPosition({
			x: pageX,
			y: pageY,
		});

		setShowPopover(true);
	};

	const handleLongPress = (event: GestureResponderEvent) => {
		if (props.disabled === true) {
			return;
		}

		const { pageX, pageY } = event.nativeEvent;

		setPopoverPosition({
			x: pageX,
			y: pageY,
		});

		setShowPopover(true);
	};

	const handleError = () => {
		if (quoteType == MessageType.IMAGE && imageUrl && !imageUrl.startsWith('http:') && content.length !== 0) {
			setImageUrl(fixRemoteUrl(content));
		}
	};

	async function getQuoteUserName(quoteUid: string, quoteUser: string) {
		if (Number(quoteUid) === getUid()) {
			return Str_You;
		}

		const isGroup = isGroupTopic(quoteMeta.quoteTid);

		// 如果不是转发消息
		if (props.msg?.type !== MessageType.TALK) {
			// 如果是群消息
			if (isGroup) {
				const quoteGroupDetail = await ImSdk.getInstance().GetGroupDetail(quoteMeta.quoteTid);
				if (quoteGroupDetail) {
					const member = quoteGroupDetail.members?.find(m => `${m.uid}` === quoteUid);

					// console.log('[quoteGroupDetail]: ', JSON.stringify(member));
					if (member) {
						return getDisplayName(member);
					}
				}
				// 如果在群里找不到这个用户，继续往下走下面的逻辑，可能是好友消息，也可能是陌生人消息
			}
			// 不是群组继续让下走下面的逻辑，可能是好友消息，也可能是陌生人消息
			return getQuoteUserDefaultName(isGroup, quoteUid, quoteUser);
		}

		// 如果是转发消息, 可能是好友消息，也可能是陌生人消息
		return getQuoteUserDefaultName(isGroup, quoteUid, quoteUser);
	}


	const getQuoteUserDefaultName = (isGroup: boolean, quoteUid: string, quoteUser: string) => {
		// 如果是好友, 优先显示好友的备注
		const localUser = state?.contactList?.find(user => `${user.uid}` === quoteUid);
		if (localUser) {
			if (isGroup) {
				return localUser.nick || localUser.name || localUser.employee;
			}
			return getDisplayName(localUser);
		}


		return quoteUser || '';
	}

	function onMenuClick(value: string) {
		if (value === 'Locate') {
			// 定位
			if (props.msg) {
				props.handleQuoteLocal?.(props.msg);
			}
		}
	}

	const QuoteContentComponent = (
		<ChatPopMenu
			setShowPopover={setShowPopover}
			popoverPosition={popoverPosition}
			showPopover={showPopover}
			onMenuClick={onMenuClick}
			quote={quoteMeta}>
			<Pressable disabled={props.disabled === true} onPress={handleClick} onLongPress={handleLongPress}>
				<View
					{...(Platform.OS === 'web' && {
						onContextMenu: handleContextMenu,
					})}
					style={[{ paddingVertical: 5, paddingHorizontal: 20 }, props.style]}>
					{(quoteType === MessageType.IMAGE) && (
						<View style={{ flexDirection: 'row', justifyContent: 'center' }}>
							{quoteUserName.length > 0 && (
								<Text disabled={true} style={styles.quoteText}>
									{`${quoteUserName}:`}
								</Text>
							)}

							<View style={{ position: 'relative', width: 28, height: 28, overflow: 'hidden', borderRadius: 2 }}>
								<FastImage
									onError={handleError}
									style={styles.quoteImg}
									source={{
										uri: fixRemoteUrl(quoteMeta?.quoteCnt || ''),
										priority: FastImage.priority.normal, // 优先级
										cache: FastImage.cacheControl.immutable, // 缓存策略
									}}
								/>
							</View>
						</View>
					)}

					{(quoteType === MessageType.VIDEO) && (
						<View style={{ flexDirection: 'row', justifyContent: 'center' }}>
							{quoteUserName.length > 0 && (
								<Text disabled={true} style={styles.quoteText}>
									{`${quoteUserName}:`}
								</Text>
							)}

							<View style={{ position: 'relative', width: 28, height: 28, overflow: 'hidden', borderRadius: 2 }}>
								{/* Web 原生 video */}
								<video
									src={fixRemoteUrl(quoteMeta?.quoteCnt || '')}
									muted
									preload="metadata"
									playsInline
									style={{
										width: "32",
										height: "32",
										objectFit: "cover",
										borderRadius: 5,
										backgroundColor: "#000",
									}}
								/>
								<Image
									style={{
										position: 'absolute',
										top: '50%', // 顶部定位到50%
										left: '50%', // 左侧定位到50%
										transform: [
											{ translateX: -8 }, // 向左移动自身宽度的一半
											{ translateY: -8 }, // 向上移动自身高度的一半
										],
										width: 16,
										height: 16,
									}}
									source={require('../../../assets/image/icon_play.png')}
								/>
							</View>
						</View>
					)}

					{quoteType === MessageType.VOICE && (
						<View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
							{quoteUserName.length > 0 && (
								<Text disabled={true} style={styles.quoteText}>
									{`${quoteUserName}:`}
								</Text>
							)}
							<LottieView
								ref={lottie}
								style={{
									height: 18,
									width: 20,
								}}
								source={source}
								imageAssetsFolder={'lottie/images'}
								autoPlay={false}
								resizeMode={'contain'}
							/>
							<Text
								style={[
									textStyle,
									{
										paddingLeft: 4,
										paddingRight: 8,
									},
								]}
							>
								{`${Math.floor(quoteMeta.duration)}″`}
							</Text>
						</View>
					)}

					{(quoteType === MessageType.TEXT ||
						quoteType === MessageType.TALK ||
						quoteType === MessageType.RTC_VOICE ||
						quoteType === MessageType.DOCUMENT ||
						quoteType === MessageType.RTC_VIDEO) && (
							<Text disabled={true} numberOfLines={maxLine} style={styles.quoteText}>
							{quoteUserName.length > 0 && (
								<Text disabled={true} style={styles.quoteText}>
									{`${quoteUserName}:`}
								</Text>
							)}
							{`${quoteMeta?.quoteType === MessageType.TALK
									? `[${Str_ChatRecord}]`
									: quoteMeta?.quoteType === MessageType.RTC_VIDEO
										? `[${Str_RtcVideo}]`
										: quoteMeta?.quoteType === MessageType.RTC_VOICE
											? `[${Str_RtcAudio}]`
											: quoteMeta?.quoteType === MessageType.DOCUMENT
												? `[${Str_File}]`
												: (quoteMeta?.quoteCnt || '')
									}`}
							</Text>
						)}
				</View>
			</Pressable>
		</ChatPopMenu>
	);

	return QuoteContentComponent;
};

export const QuoteContentRender = React.memo(QuoteRender, (prevProps, nextProps) => {
	return prevProps === nextProps;
});

const styles = StyleSheet.create({
	quoteText: {
		paddingLeft: 4,
		paddingRight: 8,
		paddingVertical: 4,
		color: color_666666,
		maxWidth: 250,
	},

	quoteImg: {
		aspectRatio: 1,
		marginTop: 0,
		marginBottom: 0,
		borderRadius: 2,
		backgroundColor: color_999999,
	},
});
